import { Tooltip } from "components/Common/Tooltip/Tooltip";
import { HelpCircle } from "./Icons";
import styles from "./helpTooltip.module.scss";
import classnames from "classnames/bind";
import { useState } from "react";

const classNameBuilder = classnames.bind(styles);

export const HelpTooltip = ({
  className,
  iconClassName,
  children,
  width,
  ...rest
}) => {
  const [forceOpen, setForceOpen] = useState();
  return (
    <div className={classNameBuilder("container", className)}>
      <HelpCircle
        className={classNameBuilder(iconClassName, { active: forceOpen })}
        onClick={() => setForceOpen((prev) => (prev ? undefined : true))}
      />
      <Tooltip
        style={width ? { width } : undefined}
        showing={forceOpen}
        {...rest}
      >
        {children}
      </Tooltip>
    </div>
  );
};
